import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./page.css";
import {
  useCreateOrUpdateBoxMutation,
  useGetBoxQuery,
} from "../store/api/boxApi";
import { boxColumn } from "../metadata/box";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { Toast } from "primereact/toast";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addBox } from "../store/slices/box";
import { generateTrackingCode } from "./SetUser";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import { useTranslation } from "react-i18next";

function Box() {
  const { t } = useTranslation();
  const boxColumnTr = useTranslatedColumns(boxColumn);
  const { boxId } = useParams();
  const [activeTab, setActiveTab] = useState(undefined);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, error, isLoading } = useGetBoxQuery({
    guid: undefined,
    boxId: undefined,
    status: activeTab
  });
  const toast = useRef(null);
  const [createOrUpdateBox] = useCreateOrUpdateBoxMutation();
  const tabItems = [
    { label: "all", value: undefined },
    { label: "atSclad", value: 0 },
    { label: "sended", value: 16 },
    { label: "atIssue", value: 18 },
  ];

  const actions = useActionsHook([
    {
      onClick: (param, data) => {
        if (data.status == 3 || data.status == 16 || data.status == 18) {
          navigate("/box-seems/" + data?.tracking_code);
          return
        }

        navigate("/scannerPanel/" + data?.tracking_code);
        dispatch(addBox(data));
      },
      icon: "pi pi-eye",
    },
  ]);
  const items = [
    {
      label: "Add",
      icon: "pi pi-pencil",
      command: () => {
        // toast.current.show({ severity: 'info', summary: 'Add', detail: 'Data Added' });
      },
    },
    {
      label: "Update",
      icon: "pi pi-refresh",
      command: () => {
        // toast.current.show({ severity: 'success', summary: 'Update', detail: 'Data Updated' });
      },
    },
    {
      label: "Delete",
      icon: "pi pi-trash",
      command: () => {
        // toast.current.show({ severity: 'error', summary: 'Delete', detail: 'Data Deleted' });
      },
    },
    {
      label: "Upload",
      icon: "pi pi-upload",
      command: () => {
        // router.push('/fileupload');
      },
    },
    {
      label: "React Website",
      icon: "pi pi-external-link",
      command: () => {
        // window.location.href = 'https://react.dev/';
      },
    },
  ];

  const [formData, setFormData] = useState({
    boxId: boxId,
  });

  const [visibleLeft, setVisibleLeft] = useState({
    visible: false,
    data: null,
  });

  function toggleSidebar(bool, data) {
    if (data?.status == 3 || data?.status == 16 || data?.status == 18) {
      return
    }
    setFormData(data);
    setVisibleLeft((state) => {
      return {
        visible: bool,
        data: data,
      };
    });
  }

  const onBlur = (e, attr, value) => {
    setFormData((state) => {
      return {
        ...state,
        [attr]: value,
      };
    });
  };
  return (
    <>
      <Toast ref={toast} />
      <p
        style={{
          paddingLeft: 12,
          fontSize: 18,
          fontWeight: 600,
          margin: "8px 0"
        }}
      >
        {t("box")}
      </p>
      <div style={{ paddingLeft: 12, marginBottom: 0 }}>
        {tabItems.map((tab) => (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            style={{
              marginRight: 10,
              padding: "4px 16px",
              borderRadius: 8,
              border: "none",
              backgroundColor: activeTab === tab.value ? "#007ad9" : "#e0e0e0",
              color: activeTab === tab.value ? "#fff" : "#333",
              cursor: "pointer",
            }}
          >
            {t(tab.label)}
          </button>
        ))}
      </div>
      <PresortDemo
        isLoading={isLoading}
        data={data}
        scrollHeight={"calc(100vh - 160px)"}
        column={boxColumnTr}
        toggleSidebar={toggleSidebar}
        deleteHandler={(row, field) => {
          console.log(row, field);
        }}
        actions={actions}
      />
      <SpeedDial
        model={items}
        radius={120}
        type="quarter-circle"
        onClick={() => {
          toggleSidebar(true, {});
        }}
        direction="up-left"
        style={{ right: 15, bottom: 15 }}
      />
      <Sidebar
        visible={visibleLeft.visible}
        position="right"
        onHide={() => {
          toggleSidebar(false);
        }}
        style={{ width: "50vw" }}
      >
        <div className="user-sidebar">
          {!formData?.guid && (
            <div className="inp_button">
              <div
                style={{
                  width: "calc(100% - 140px)",
                }}
              >
                <Editor
                  label={t("tracking_code")}
                  data={formData}
                  attr="tracking_code"
                />
              </div>
              <MyButton
                label={t("generateCod")}
                onClick={async () => {
                  setFormData((prev) => ({
                    ...prev,
                    tracking_code: generateTrackingCode("NBX"),
                  }));
                }}
              />
            </div>
          )}
          <div className="user-sidebar-edit">
            {boxColumn
              .filter((i) => i.editor)
              .map((el) => {
                return (
                  <div>
                    <Editor {...el} onBlur={onBlur} data={formData} label={t(el.label)} />
                  </div>
                );
              })}

            <div></div>
            <MyButton
              label={t("save")}
              onClick={async () => {
                await createOrUpdateBox(formData);
                await console.log(formData);
                toast.current.show({
                  severity: "info",
                  summary: "Success",
                  detail: t("successSaved"),
                  life: 3000,
                });
                toggleSidebar(false);
              }}
            />
          </div>
        </div>
      </Sidebar>
    </>
  );
}

export default Box;
